import React from "react";
import { motion } from "framer-motion";
import { MdWork } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import { FaLaptopCode, FaGraduationCap } from "react-icons/fa";
import ResumeTitle from "./ResumeTitle";
import ResumeCard from "./ResumeCard";

const Education = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <div className="w-full px-6 py-12 bg-gray-900">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          visible: { transition: { staggerChildren: 0.2 } }
        }}
        className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-9 gap-8"
      >
        {/* Опыт работы */}
        <motion.div
          variants={fadeIn}
          className="col-span-1 lg:col-span-4 bg-gray-800 p-6 rounded-xl shadow-lg border-l-4 border-blue-500"
        >
          <ResumeTitle
            title="ПРОДАКШН"
            icon={<FaLaptopCode className="text-blue-400" />}
          />
          <div className="space-y-6 mt-6">
            <ResumeCard
              badge="2025 - 2027"
              title="Front-end Developer"
              subTitle="Kazingo (Internship)"
              des={
                <ul className="list-disc pl-5 space-y-2 text-gray-300">
                  <li>Разработка SPA на React/Next.js</li>
                  <li>Интеграция платежных систем (Stripe, PayPal)</li>
                  <li>Оптимизация производительности (Lighthouse 90+)</li>
                  <li>Работа в Agile-команде (Scrum, Jira)</li>
                </ul>
              }
              icon={<MdWork className="text-xl text-blue-400" />}
            />
          </div>
        </motion.div>

        {/* Вертикальный разделитель */}
        <div className="hidden lg:flex justify-center items-center col-span-1">
          <div className="w-px h-full bg-gray-700"></div>
        </div>

        {/* Образование */}
        <motion.div
          variants={fadeIn}
          className="col-span-1 lg:col-span-4 bg-gray-800 p-6 rounded-xl shadow-lg border-l-4 border-purple-500"
        >
          <ResumeTitle
            title="ОБРАЗОВАНИЕ"
            icon={<FaGraduationCap className="text-purple-400" />}
          />
          <div className="space-y-6 mt-6">
            <ResumeCard
              badge="2024 - 2026"
              title="Full Stack Development"
              subTitle="IT Step Academy"
              des={
                <ul className="list-disc pl-5 space-y-2 text-gray-300">
                  <li>Дипломный проект: платформа для онлайн-обучения</li>
                  <li>Стек: MERN (MongoDB, Express, React, Node.js)</li>
                  <li>Система проверки заданий с AI-ассистентом</li>
                  <li>Аналитика успеваемости студентов</li>
                </ul>
              }
              icon={<GiGraduateCap className="text-xl text-purple-400" />}
            />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Education;